"use strict";

exports.__esModule = true;
exports.PasswordEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _owaspPasswordStrengthTest = _interopRequireDefault(require("owasp-password-strength-test"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _index = require("../FormGroupField/index");
var _index2 = require("../../Core/Translator/index");
var _index3 = require("../../Core/RequiredLabel/index");
var _reactIntl = require("react-intl");
var _class, _PasswordEditor;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
_owaspPasswordStrengthTest["default"].config({
  allowPassphrases: true,
  minPhraseLength: 20,
  maxLength: 128,
  minLength: 10,
  minOptionalTestsToPass: 3
});
var PasswordDescription = _styledComponents["default"].div.withConfig({
  displayName: "PasswordEditor__PasswordDescription",
  componentId: "sc-xgy4cd-0"
})(["width:100%;"]);
var PasswordDescriptionListWrapper = _styledComponents["default"].ul.withConfig({
  displayName: "PasswordEditor__PasswordDescriptionListWrapper",
  componentId: "sc-xgy4cd-1"
})(["padding-left:1rem;"]);
var PasswordDescriptionListSeparator = _styledComponents["default"].div.withConfig({
  displayName: "PasswordEditor__PasswordDescriptionListSeparator",
  componentId: "sc-xgy4cd-2"
})(["margin:auto;"]);
var PasswordListItem = _styledComponents["default"].li.withConfig({
  displayName: "PasswordEditor__PasswordListItem",
  componentId: "sc-xgy4cd-3"
})(["text-decoration:none;"]);
var ParaphrasePolicyCheck = function ParaphrasePolicyCheck(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.passphrase ? /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-label": ""
  }, "\xA0 \u2705") : null);
};
var PasswordEditor = exports.PasswordEditor = (0, _index2.withTranslator)(_class = (_PasswordEditor = /*#__PURE__*/function (_Component) {
  function PasswordEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      errors: [],
      isPassphrase: false
    };
    _this.validatePassword = function (value) {
      var _this$props = _this.props,
        translator = _this$props.translator,
        id = _this$props.id,
        allowEmptyPassword = _this$props.allowEmptyPassword;
      var translate = translator.translate;
      var _owasp$test = _owaspPasswordStrengthTest["default"].test(value || ""),
        errors = _owasp$test.errors,
        isPassphrase = _owasp$test.isPassphrase;
      if (allowEmptyPassword && id && (!value || !value.trim())) {
        _this.setState({
          errors: undefined,
          isPassphrase: true
        });
        return undefined;
      }
      _this.setState({
        errors: errors,
        isPassphrase: isPassphrase
      });
      if (errors.length === 0) return undefined;
      return translate("PasswordEditor.validatePassword.invalid", "Invalid Password");
    };
    _this.validateRePassword = function (value, allValues) {
      var translator = _this.props.translator;
      var translate = translator.translate;
      if ((allValues.rePassword || "") !== (allValues.password || "")) {
        return translate("PasswordEditor.validateRePassword.mustMatch", "Should match the password");
      }
    };
    return _this;
  }
  _inheritsLoose(PasswordEditor, _Component);
  var _proto = PasswordEditor.prototype;
  _proto.render = function render() {
    var _this$state = this.state,
      isPassphrase = _this$state.isPassphrase,
      errors = _this$state.errors;
    var _this$props2 = this.props,
      translator = _this$props2.translator,
      id = _this$props2.id,
      disabled = _this$props2.disabled;
    var translate = translator.translate;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_index.FormGroupField, {
      name: "password",
      label: translate("PasswordEditor.password.label", "Password"),
      requiredLabel: !id ? /*#__PURE__*/_react["default"].createElement(_index3.RequiredLabel, null) : null,
      validate: this.validatePassword
    }, function (_ref) {
      var input = _ref.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({}, input, {
        type: "password",
        "data-testid": "password",
        disabled: disabled
      }));
    }), /*#__PURE__*/_react["default"].createElement(_index.FormGroupField, {
      name: "rePassword",
      label: translate("PasswordEditor.rePassword.label", "Re-Enter Password"),
      requiredLabel: !id ? /*#__PURE__*/_react["default"].createElement(_index3.RequiredLabel, null) : null,
      validate: this.validateRePassword
    }, function (_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({}, input, {
        type: "password",
        "data-testid": "rePassword",
        disabled: disabled
      }));
    }), /*#__PURE__*/_react["default"].createElement(PasswordDescription, null, /*#__PURE__*/_react["default"].createElement(PasswordDescriptionListWrapper, null, /*#__PURE__*/_react["default"].createElement(PasswordListItem, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PasswordEditor.HelperText.Passphrase",
      defaultMessage: "A valid passphrase of length at least 20"
    }), /*#__PURE__*/_react["default"].createElement(ParaphrasePolicyCheck, {
      passphrase: errors && isPassphrase
    }))), /*#__PURE__*/_react["default"].createElement(PasswordDescriptionListSeparator, null, "(or)"), /*#__PURE__*/_react["default"].createElement(PasswordDescriptionListWrapper, null, /*#__PURE__*/_react["default"].createElement(PasswordListItem, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PasswordEditor.Error.LowerCaseRequired",
      defaultMessage: "At least one lower case letter"
    }), /*#__PURE__*/_react["default"].createElement(ParaphrasePolicyCheck, {
      passphrase: errors && !errors.some(function (e) {
        return e.match(/lowercase/gi);
      })
    })), /*#__PURE__*/_react["default"].createElement(PasswordListItem, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PasswordEditor.Error.UpperCaseRequired",
      defaultMessage: "At least one upper case letter"
    }), /*#__PURE__*/_react["default"].createElement(ParaphrasePolicyCheck, {
      passphrase: errors && !errors.some(function (e) {
        return e.match(/uppercase/gi);
      })
    })), /*#__PURE__*/_react["default"].createElement(PasswordListItem, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PasswordEditor.Error.NumberRequired",
      defaultMessage: "At least one number"
    }), /*#__PURE__*/_react["default"].createElement(ParaphrasePolicyCheck, {
      passphrase: errors && !errors.some(function (e) {
        return e.match(/number/gi);
      })
    })), /*#__PURE__*/_react["default"].createElement(PasswordListItem, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PasswordEditor.Error.SpecialCharacterRequired",
      defaultMessage: "At least one special character"
    }), /*#__PURE__*/_react["default"].createElement(ParaphrasePolicyCheck, {
      passphrase: errors && !errors.some(function (e) {
        return e.match(/special/gi);
      })
    })), /*#__PURE__*/_react["default"].createElement(PasswordListItem, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PasswordEditor.Error.MaxLength",
      defaultMessage: "Fewer than 128 characters"
    }), /*#__PURE__*/_react["default"].createElement(ParaphrasePolicyCheck, {
      passphrase: errors && !errors.some(function (e) {
        return e.match(/128 /gi);
      })
    })), /*#__PURE__*/_react["default"].createElement(PasswordListItem, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PasswordEditor.Error.MinLength",
      defaultMessage: "At least 10 characters long"
    }), /*#__PURE__*/_react["default"].createElement(ParaphrasePolicyCheck, {
      passphrase: errors && !errors.some(function (e) {
        return e.match(/10 /gi);
      })
    })))));
  };
  return PasswordEditor;
}(_react.Component), _PasswordEditor.defaultProps = {
  translator: undefined
}, _PasswordEditor)) || _class;